import { render, staticRenderFns } from "./contain.vue?vue&type=template&id=42f38744&"
import script from "./contain.vue?vue&type=script&lang=js&"
export * from "./contain.vue?vue&type=script&lang=js&"
import style0 from "./contain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports